import React from 'react'

import {
  Spinner,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, object, func, string } from 'prop-types'

import CartItemsList from 'Pods/UnifiedNavigation/Shared/CartItemsList/CartItemsList'
import EmptyContent from 'Pods/UnifiedNavigation/Shared/EmptyContent/EmptyContent'

function WishlistItems({
  wishlistItems,
  isWishlistLoading,
  isWishListErrored,
  fetchData,
  isCartBelowThreshold,
  isCartAboveThreshold,
  shouldShowCartProgress,
  trackAddToCart,
  locale = 'en',
}) {
  function handleTrackAddToCart(id, index) {
    const matchingItem = wishlistItems.meta.trackingRecentItems
      .find(item => item.itemId === id)

    trackAddToCart({
      ...matchingItem,
      source: 'cart-wishlist',
      index,
    })
  }

  if (wishlistItems.data.length === 0 && isWishlistLoading ) {
    return (
      <div className="row justify-content-center cgt-mt-16 cgt-mr-10 cgt-ml-10 cgt-mb-10">
        <Spinner size="small" />
      </div>
    )
  }

  if (wishlistItems.meta.totalCount) {
    return (
      <div className="popover__cart cgt-mt-16">
        <CartItemsList
          items={wishlistItems.data}
          included={wishlistItems.included}
          onLoadNextPage={() => fetchData(wishlistItems.page + 1)}
          hasError={isWishListErrored}
          isLastPageLoaded={wishlistItems.isLastPageLoaded}
          trackCartRemoveGA4={() => { }}
          trackAddToCart={handleTrackAddToCart}
          isCartBelowThreshold={isCartBelowThreshold}
          isCartAboveThreshold={isCartAboveThreshold}
          shouldShowCartProgress={shouldShowCartProgress}
          actionType='add'
          listType="cart-wishlist"
          useIncludedData={false}
        />
      </div>
    )
  }

  return (
    <EmptyContent variation="wishlist-tab" locale={locale} />
  )
}

WishlistItems.propTypes = {
  wishlistItems: object.isRequired,
  isWishlistLoading: bool.isRequired,
  isWishListErrored: bool.isRequired,
  fetchData: func.isRequired,
  isCartBelowThreshold: bool.isRequired,
  isCartAboveThreshold: bool.isRequired,
  shouldShowCartProgress: bool.isRequired,
  locale: string,
  trackAddToCart: func.isRequired,
}

export default WishlistItems
